import { permissionTree, RESOURCE_MANTENIMIENTO } from '@/auth/permissions/modules/mantenimientoMaquinariaPg'
import {
    ROUTE_MANTENIMIENTO_GESTION_AREAS_MANPROG,
    ROUTE_MANTENIMIENTO_GESTION_ESTRATEGIA,
    ROUTE_MANTENIMIENTO_GESTION_MAQUINARIA,
    ROUTE_MANTENIMIENTO_GESTION_MODELO,
    ROUTE_MANTENIMIENTO_GESTION_PLAN_MANTENIMIENTO,
    ROUTE_MANTENIMIENTO_PROCESOS,
} from '@/router/routes/mantenimiento-pg/nombres/mantenimiento'
import { defineMenu } from '@/utils/menu'

const { mantenimiento } = permissionTree
export default defineMenu([
    {
        title: 'manprog.subopciones.gestion_plan_mantenimiento',
        action: mantenimiento.gestionPlanMantenimiento,
        resource: RESOURCE_MANTENIMIENTO,
        route: ROUTE_MANTENIMIENTO_GESTION_PLAN_MANTENIMIENTO,
    },
    {
        title: 'manprog.subopciones.gestion_modelo',
        action: mantenimiento.gestionModelo,
        resource: RESOURCE_MANTENIMIENTO,
        route: ROUTE_MANTENIMIENTO_GESTION_MODELO,
    },
    {
        title: 'manprog.subopciones.gestion_estrategias',
        action: mantenimiento.gestionEstrategia,
        resource: RESOURCE_MANTENIMIENTO,
        route: ROUTE_MANTENIMIENTO_GESTION_ESTRATEGIA,
    },
    {
        title: 'manprog.subopciones.gestion_procesos',
        action: mantenimiento.procesos,
        resource: RESOURCE_MANTENIMIENTO,
        route: ROUTE_MANTENIMIENTO_PROCESOS,
    },
    {
        title: 'manprog.subopciones.gestion_area',
        action: mantenimiento.area,
        resource: RESOURCE_MANTENIMIENTO,
        route: ROUTE_MANTENIMIENTO_GESTION_AREAS_MANPROG,
    },
    {
        title: 'manprog.subopciones.gestion_maquinaria',
        action: mantenimiento.crearMaquinaria,
        resource: RESOURCE_MANTENIMIENTO,
        route: ROUTE_MANTENIMIENTO_GESTION_MAQUINARIA,
    },
])
